<script lang="ts">
	import { cn } from '$lib/utils';
	import type { HTMLAttributes } from 'svelte/elements';

	type $$Props = HTMLAttributes<HTMLElement> & {
		el?: HTMLElement;
	};

	export let el: $$Props['el'] = undefined;
	let className: $$Props['class'] = undefined;
	export { className as class };
</script>

<nav class={cn('font-medium', className)} bind:this={el} aria-label="breadcrumb" {...$$restProps}>
	<slot />
</nav>
